<template>
  <div>
    <wt-paged-table
      :on-request-data="getTableData"
      :total-size="totalNumber"
      :page-size="pageSize"
      ref="table"
      :isAddPageToRouter="true"
      :refresh="false"
    >
      <el-table
        :data="tableData"
        stripe
        style="width: 100%; margin-top: 20px"
        :row-class-name="newNotification"
      >
        <el-table-column prop="read" label="" width="80">
          <template slot-scope="scope" v-if="!scope.row.read">
            <div class="new-tag">NEW</div>
          </template>
        </el-table-column>
        <el-table-column prop="operator" label="操作人" width="130">
        </el-table-column>
        <el-table-column
          prop="createdDate"
          label="操作时间"
          width="170"
        ></el-table-column>
        <el-table-column
          prop="content"
          label="操作内容"
          width="800"
        ></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="goDetail(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </wt-paged-table>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = "reservation-notifications-table";

export default {
  name: "reservation-notifications-table",
  computed: {
    classes() {
      return `${prefixCls}`;
    },
    page() {
      return this.$refs.table.page;
    }
  },
  props: {
    totalNumber: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    },
    tableLabels: {
      type: Array,
      default: function() {
        return [];
      }
    },
    tableData: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  methods: {
    newNotification({ row, rowIndex }) {
      return row.read ? "old" : "new-notification";
    },
    goDetail(row) {
      this.$store
        .dispatch("setNotificationsIsRead", row.id)
        .then(() => {})
        .catch(err => {
          this.$message.error(err || "请求失败");
        });
      this.$router.push("/reservation-detail/" + row.reservationId);
    },

    resetPage() {
      this.$refs.table.resetPage();
    },
    getTableData(page, next) {
      this.$emit("getTableData", page, next);
    }
  }
};
</script>

<style scoped lang="less">
/deep/ .new-notification {
  font-weight: bold;
}
.new-tag {
  background-color: #edbe81;
  width: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  border-radius: 0.04rem;
  color: white;
}
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
</style>
